import Swiper from 'swiper';

$(function(){
  new Swiper('.kn-content-section-16 .swiper-container', {
    slidesPerView: 1,
    loop: true,
    // loopFillGroupWithBlank: false,
    freeMode: true,
    // pagination: {
    //   el: '.swiper-pagination',
    //   clickable: true,
    // },
    breakpoints: {
      380: {
        slidesPerView: 2,
      },
      576: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 4,
      },
      992: {
        slidesPerView: 5,
      },
      1200: {
        slidesPerView: 6,
      }
    }
  });
});